// extracted by mini-css-extract-plugin
module.exports = {"table":"ActivationTable_table__35qFO","totalColumnHeadCell":"ActivationTable_totalColumnHeadCell__1jY1F"};